import { useEffect, useState } from "react";
import axios from "axios";
import { AlertTriangle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PhoneFrame = ({ html, whatsapp, problems }) => {
  const [tab, setTab] = useState("email");
  return (
    <div className="w-[300px] shrink-0" data-testid="phone-preview">
      <div className="flex gap-1 mb-2 justify-center">
        {["email", "whatsapp"].map((t) => (
          <button key={t} type="button" onClick={() => setTab(t)} data-testid={`phone-tab-${t}`}
            className={`px-3 py-1 rounded-full text-xs ${tab === t ? "bg-sky-900 text-white" : "bg-sky-50 text-sky-700"}`}>
            {t === "email" ? "Email" : "WhatsApp"}
          </button>
        ))}
      </div>
      <div className="rounded-[2.2rem] border-[10px] border-slate-900 bg-slate-900 shadow-xl overflow-hidden">
        <div className="h-5 bg-slate-900 flex justify-center"><div className="w-16 h-1.5 rounded-full bg-slate-700 mt-1.5" /></div>
        {tab === "email" ? (
          <iframe title="Vista celular" srcDoc={html || ""} sandbox="" className="w-full h-[520px] bg-white" data-testid="phone-preview-iframe" />
        ) : (
          <div className="h-[520px] bg-[#e5ddd5] p-3 overflow-y-auto">
            <div className="bg-[#dcf8c6] rounded-lg rounded-tr-none p-2.5 text-[13px] whitespace-pre-wrap [overflow-wrap:anywhere] text-slate-900 shadow-sm ml-6" data-testid="phone-preview-whatsapp">{whatsapp}</div>
          </div>
        )}
      </div>
      {problems?.length > 0 && (
        <p className="text-xs text-red-600 mt-2 flex gap-1"><AlertTriangle className="w-3.5 h-3.5 shrink-0" />{problems.join("; ")}</p>
      )}
    </div>
  );
};

export const PhonePreview = ({ html, kind, axiosConfig }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    const id = setTimeout(() => {
      axios
        .post(`${API}/templates/preview-sample`, { html, kind, frontend_url: window.location.origin }, axiosConfig)
        .then((r) => setData(r.data))
        .catch(() => setData(null));
    }, 400);
    return () => clearTimeout(id);
    // eslint-disable-next-line
  }, [html, kind]);
  return (
    <div>
      <p className="text-[11px] text-sky-600/70 text-center mb-1">Con datos de ejemplo (Juan · Cancún · sale en 7 días)</p>
      <PhoneFrame html={data?.html} whatsapp={data?.whatsapp} problems={data?.problems} />
    </div>
  );
};
